import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { MegaMenuItemsContainer } from './styles';
import MegaMenuItem from './MegaMenuItem';
import { menuItems } from './menuItems';
export var MegaMenu = function MegaMenu(_ref) {
  var isCSPLiveOnboarding = _ref.isCSPLiveOnboarding;
  var items = !isCSPLiveOnboarding ? menuItems.filter(function (item) {
    return !item.isCSPLive;
  }) : menuItems;
  return /*#__PURE__*/React.createElement(MegaMenuItemsContainer, null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(MegaMenuItem, _extends({}, item, {
      key: index
    }));
  }));
};
MegaMenu.displayName = 'MegaMenu';
export default /*#__PURE__*/memo(MegaMenu);